export const ClassroomTrainingTypeDecorator = {
  url() {
    return `signup-hubspot/classroom-training`;
  },
  query() {
    return {};
  }
};